export default {
  logs(state) {
    return state.logs
  },
  logFilters(state) {
    return state.logFilters
  },
  logModelTypes(state) {
    return state.logModelTypes
  },
  logEvents(state) {
    return state.logEvents
  },
  objectTypes() {
    return [
      {
        id: 'App\\Models\\Booking',
        title: 'Заявка',
        action_name: 'заявки',
        fields: {
          status_id: 'статус',
          user_id: 'пользователь',
          duration: 'продолжительность',
          comment: 'комментарий',
        },
      },
      {
        id: 'App\\Models\\Company',
        title: 'Компания',
        action_name: 'компании',
        fields: {
          name: 'название',
        },
      },
      {
        id: 'App\\Models\\Employer',
        title: 'Сотрудник',
        action_name: 'сотрудника',
        fields: {
          first_name: 'имя',
          last_name: 'фамилия',
          middle_name: 'отчество',
          email: 'email',
          phone: 'телефон',
          status: 'статус',
          unit_id: 'студия',
        },
      },
      {
        id: 'App\\Models\\EmployerSchedule',
        title: 'Расписание',
        action_name: 'расписания',
        fields: {
          employer_id: 'сотрудник',
          begin_at: 'начало',
          end_at: 'конец',
          unit_id: 'салон',
          workplace_id: 'рабочее место',
          service_category_id: 'категория',
        },
      },
      {
        id: 'App\\Models\\User',
        title: 'Клиент',
        action_name: 'Клиента',
        fields: {
          first_name: 'имя',
          last_name: 'фамилия',
          middle_name: 'отчество',
          email: 'email',
          phone: 'телефон',
        },
      },
      {
        id: 'App\\Models\\Service',
        title: 'Услуга',
        action_name: 'услуги',
        fields: {
          service_category_id: 'категория',
          parent_service_id: 'родительская услуга',
          title: 'название',
          title_online: 'название online',
          title_cashier: 'название в чеке',
          article: 'артикул',
          barcode: 'штрих-код',
          duration: 'продолжительность',
        },
      },
      {
        id: 'App\\Models\\ServiceCategory',
        title: 'Категория услуги',
        action_name: 'категории',
        fields: {
          title: 'название',
        },
      },
      {
        id: 'App\\Models\\ServicePrice',
        title: 'Цена услуги',
        action_name: 'цены',
        fields: {
          unit_id: 'студия',
          company_id: 'компания',
          service_id: 'услуга',
          begin_at: 'начало',
          end_at: 'конец',
          price: 'цена',
        },
      },
      {
        id: 'App\\Models\\ServiceResource',
        title: 'Ресурс услуги',
        action_name: 'ресурса',
        fields: {
          service_id: 'услуга',
          company_id: 'компания',
          type: 'тип',
          count: 'количество',
        },
      },
      {
        id: 'App\\Models\\Unit',
        title: 'Студия',
        action_name: 'студии',
        fields: {
          location_type: 'тип населенного пункта',
          location_id: 'населенный пункт',
          company_id: 'компания',
          name: 'название',
          address: 'адрес',
          latitude: 'широта',
          longitude: 'долгота',
          time_sampling: 'время',
        },
      },
      {
        id: 'App\\Models\\UnitGroup',
        title: 'Группа студий',
        action_name: 'группы',
        fields: {
          name: 'название',
        },
      },
      {
        id: 'App\\Models\\UnitSchedule',
        title: 'Расписание студии',
        action_name: 'расписания',
        fields: {
          unit_id: 'студия',
          company_id: 'компания',
          begin_at: 'начало',
          schedule: 'расписание',
        },
      },
      {
        id: 'App\\Models\\Window',
        title: 'Окно',
        action_name: 'окна',
        fields: {
          unit_id: 'студия',
          employer_id: 'сотрудник',
          employer_schedule_id: 'расписание сотрудника',
          workplace_id: 'рабочее место',
          booking_id: 'заявка',
          begin_at: 'начало',
          end_at: 'конец',
          duration_original: 'продолжительность original',
          duration: 'продолжительность',
        },
      },
    ]
  },
}
